var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('svg',_vm._g({attrs:{"viewBox":_vm.image.viewBox,"role":"img"}},_vm.$listeners),[_c('use',_vm._b({},'use',{ 'xlink:href': _vm.image.url },false))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }